import React from 'react';
import { ConversationList } from '@indeed/messaging-react';

interface ConversationListContainerProps {
    sx?: React.CSSProperties;
}

const ConversationListContainer: React.FC<ConversationListContainerProps> = ({ sx }) => {
    return <ConversationList sx={sx} />;
};

export default ConversationListContainer;
